import { o } from 'odata';

import { odataConf } from '../odata/conf';

const url = `${process.env.VUE_APP_APIURL}/odata/`;

export default {
  loadMetricTabsWithMetrics: async ({ commit, rootState }) => {
    const data = await o(url, odataConf.getConf(rootState))
      .get('metricTabs')
      .query({ $filter: 'IsDeleted eq false', $expand: 'metrics' });
    commit('metricTabsWithMetrics', data);
  },
};
